import React, {useEffect} from "react";

import EditableTableWrapper from "./EditableTableWrapper";
import {useModel1RegistryQuery, useModels1Query} from "../query";
import useDataTableSorting from "../../../components/DataTable/useDataTableSorting";
import useDataTablePagination from "../../../components/DataTable/useDataTablePagination";
import useDataTableColoring from "../../../components/DataTable/useDataTableColoring";


const initialSorting = [{id: "datetime", desc: true}];


const TableDataLoader = ({filterState, filterProps, visibleColumns, map, dataTableId}) => {
    const sortingState = useDataTableSorting(initialSorting);
    const paginationState = useDataTablePagination({dataTableId});
    const coloringState = useDataTableColoring({dataTableId});

    // Go to first page when the filters change or the sorting changes
    useEffect(() => {
        paginationState.goToFirstPage();
    }, [filterState?.filters, sortingState?.sorting, map.selectedFeatureIds]);

    const station__id__in = [
        ...map.selectedFeatureIds,
        ...(filterState.filterFetchOptions.station__id__in ?? "").split(',')
    ].filter(s => s !== "").join(",")

    const fetchDataOptions = {
        ...paginationState.paginationFetchOptions,
        ...filterState.filterFetchOptions,
        ...sortingState.sortingFetchOptions,
        station__id__in
    }

    const exportFetchDataOptions = {
        ...filterState.filterFetchOptions,
        ...sortingState.sortingFetchOptions,
        station__id__in
    }

    const tableState = {
        ...paginationState,
        ...sortingState,
        ...filterState,
        ...coloringState,
    }

    const dataQuery = useModels1Query(fetchDataOptions);
    const model1Registry = useModel1RegistryQuery();

    return <EditableTableWrapper rows={dataQuery.data?.rows}
                                 model1Registry={model1Registry.data}
                                 page_count={dataQuery.data?.page_count}
                                 loading={dataQuery.isFetching && dataQuery.isPreviousData}
                                 filterProps={filterProps}
                                 visibleColumns={visibleColumns}
                                 map={map}
                                 exportFetchDataOptions={exportFetchDataOptions}
                                 dataTableId={dataTableId}
                                 {...tableState}/>
}


export default TableDataLoader;